module.exports = __webpack_public_path__ + "img/icon-otherplace.3e3165a9.svg";